// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_AVr7O {
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  max-height: 97vh;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  background-color: var(--f5-background);
 
}

.container_AVr7O::-webkit-scrollbar {
  display: none;
}

@media (width <=768px) {
  .container_AVr7O {
    position: absolute;
    width: 100vw;
    max-width: 100vw;
    z-index: 2;
  }
}







.menuIcon_e9a25 {
  width: 20px;
  height: 20px;
  color: var(--6b7280-color);
}





.labelsContainer_gahu5 {
  display: flex;
  gap: 8px;
  padding-bottom: 8px;
}





.buttonActionsContainer_l9gIC {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;

  .linkDisabled_HQdoP {
    opacity: .2;
    cursor: not-allowed;
  }

  button,
  a {
    font-size: 12px;
    padding: 10px;
    border: 1px solid var(--d9-background);
    background-color: var(--fa-background);
    outline: none;
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    cursor: pointer;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 15px;
    font-weight: bold;
    color: black;
    display: flex;
    justify-content: start;
    align-items: center;

    img {
      height: 22px;
      width: 22px;
    }
  }

  .btnWithText_fH1_H {
    display: flex;
    align-items: center;
    gap: 15px;
    justify-content: start !important;
    font-weight: bold;
  }

  .btnAutomation_HRUlf {
    justify-content: center;
    height: 42px;

    &:disabled {
      opacity: .2;
      cursor: not-allowed;
    }

    img {
      height: 20px;
      width: 20px;
    }
  }

}

.dragOver_QUp6Y {
  border: 2px dashed var(--3b82f6-background);
  background-color: var(--e0f2fe-background);
}



.detailsContainer_xLRpm {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.btnTemplateContainer_FNFJS {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.detailsContent_LeQKe {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.containerEditableInput_RRmrV {
  padding: 0px 10px 10px;
  border: 1px solid var(--ececf1-border);
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: var(--white-background);

  .state_UW3rZ {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .stateStripeContainer_F4Xu9 {
    display: flex;
    align-items: center;
    gap: 10px;
  }
}

.searchContainerIcon_h9vWg {
  background-color: var(--ececf1-background);
  padding: 4px;
  border-radius: 4px;
  height: 10px;
  width: 10px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  -ms-border-radius: 4px;
  -o-border-radius: 4px;
  cursor: pointer;
}

.searchIconsWrappers_J36b6 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: var(--ececf1-background);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 3px;
}

.headerBillMobile_cMqTJ {
  display: flex;
  justify-content: space-between;

  button {
    background-color: transparent;
    outline: none;
    border: none;
    color: var(--_292d32-color);
    font-family: Inter;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    cursor: pointer;
  }

  .notesHeaderBillMobile_cP6CJ {
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;

    .note_ffUiM {
      display: flex;
      padding: 0 5px;
      align-items: flex-start;
      gap: 3px;
      border-radius: 5px;
    }

    button {
      color: var(--_929598-color);
      font-family: Inter;
      font-size: 8px;
      font-style: normal;
      font-weight: 500;
      line-height: 18px;
    }
  }
}

.verticalOptionDots_nGSwK {
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
}

.button_BOx4r {
  text-decoration: underline;
  font-weight: 500;
  cursor: pointer;
  width: fit-content;
}

.note_ffUiM {
  background-color: var(--_c2f2d3-background);
  border: 1px solid var(--_0000001d-border);
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;

  .text_asGg1 {
    min-height: 40px;
    height: fit-content;
    max-height: 100px;
    display: flex;
    align-items: center;
    overflow-y: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  span,
  input {
    background-color: transparent;
    font-family: "Inter", sans-serif;
    font-size: 13px;
  }

  input {
    background-color: var(--_9bd8b1fd-background);
    border: none;
  }
}

.tagWhite_Shkb5 {
  background-color: var(--white-background);
}

.tagRed_nVOXP {
  background-color: var(--f2c6c2-background);
}

.tagOrange_ftvl9 {
  background-color: var(--f2cfc2-background);
}

.tagYellow_UQu9r {
  background-color: var(--f2e3c2-background);
}

.tagGreen_PbDrp {
  background-color: var(--_c2f2d3-background);
}

.tagBlue_h5m1q {
  background-color: var(--c2d8f2-background);
}


.tagPink_LaP10 {
  background-color: var(--f0c2f2-background);
}

.titleWrapper_Hetit {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;

  div {
    display: flex;
    align-items: center;
    gap: 8px;

    img {
      width: 16px;
      height: 22px;
    }
  }

  button {
    border: none;
    outline: none;
    background-color: transparent;
    text-decoration: underline;
    color: var(--_2-color);
    font-weight: bold;
  }

  button:disabled {
    color: var(--_b4-color);
  }
}

.dropdown_eLjFE {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.dropdownContainer_auOu3 {
  display: flex;
  gap: 20px;
}

.header_zbNfG {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-bottom: 10px;
  flex-wrap: wrap;
  gap: 10px;
  border-bottom: 1px solid var(--_11a3813c-border);
}

.dropdownCurrencyContainer_qOQlk {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.titleContent_uTIEm {
  width: 100%;
}

.title_BYlhs {
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  color: var(--_084437-color);
  width: 100%;
  border-radius: 8px;
  padding: 6px;
  border: none;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  background-color: var(--f4-background);
  outline: none;
}

.title_BYlhs::placeholder {
  color: var(--_71717a-color);
}

.optionsPopupContainer_OybaP {
  position: absolute;
  z-index: 9999;
  bottom: -140px;
  right: 2px;
}

.documentsContainer_E82Cu {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;

  .document_qek7C {
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;

    img {
      height: 30px;
      width: 30px;
    }

    .acceptedDoc_h3s8p {
      color: var(--009f7a-color);
    }

    .canceledDoc_je_49 {
      color: var(--c5221f-color);
    }



 
  }

  .optionsPopupContainer_OybaP {
    position: absolute;
    z-index: 9999;
    bottom: -50px;
    right: 2px;
  }
}

.documentCanceledTag_MC_0W {
  display: flex;
  height: 31px;
  padding: 5px 22px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  gap: 10px;
  align-self: stretch;
  border-radius: 12px;
  border: 1px solid var(--f4-chatAdmin-background);
  background: var(--fff6d4-background);
  color: var(--c5221f-color);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}




.logoSelectorContainer_ugSmL {
  display: flex;
  padding: 20px;
  flex-direction: column;
  gap: 15px;
  flex: 1 0;
  border-radius: 8px;
  border: 1px solid var(--ececf1-border);
  background: var(--white-background);
}

.qrContainer_VFzpL {
  display: flex;
  padding: 20px;
  flex-direction: column;
  gap: 15px;
  flex: 1 0;
  border-radius: 8px;
  border: 1px solid var(--ececf1-border);
  background: var(--white-background);

  .qrHeader_F3Vsu {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;

    p {
      margin: 0;
      font-size: 14px;
      font-weight: 500;
      -webkit-user-select: none;
      user-select: none;
      color: var(--_2-color);
    }

    button {
      cursor: pointer;
      background: transparent;
      border: none;
      outline: none;
    }
  }

  img {
    width: 255px;
    height: 250px;
  }
}

.centedText_tsZzv {
  margin: 0px auto 10px;
  width: fit-content;
  height: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 20px;
  width: 90%;
}

.seeBillContainer_WemQi {
  position: relative;
  /* border-radius: 8px; */
  /* overflow: hidden; */
  scrollbar-width: none;
  -ms-overflow-style: none;
  scroll-behavior: smooth;
  height: 100%;

  embed {
    height: calc(100vh - 50px) !important;
    /* border-radius: 8px; */
    overflow: visible !important;
    overflow-clip-margin: unset !important;
    scrollbar-width: none;
    -ms-overflow-style: none;

    

    &::-webkit-scrollbar {
      display: none;
    }

  }


  .seeBillContainer_WemQi::-webkit-scrollbar {
    display: none;
  }

  &:hover {
    .seeBillContent_rgwZc {
      display: flex;
    }
  }

  .seeBillContent_rgwZc {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 10px 0;
    display: none;
    background-color: gray;
    color: var(--white-color);
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Preview/Preview.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,sCAAsC;;AAExC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,UAAU;EACZ;AACF;;;;;;;;AAQA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;;;;;AAMA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;;;;;AAMA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;;EAEX;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;IACf,aAAa;IACb,sCAAsC;IACtC,sCAAsC;IACtC,aAAa;IACb,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;IAEnB;MACE,YAAY;MACZ,WAAW;IACb;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iCAAiC;IACjC,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,YAAY;;IAEZ;MACE,WAAW;MACX,mBAAmB;IACrB;;IAEA;MACE,YAAY;MACZ,WAAW;IACb;EACF;;AAEF;;AAEA;EACE,2CAA2C;EAC3C,0CAA0C;AAC5C;;;;AAIA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yCAAyC;;EAEzC;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;AACF;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;;EAE9B;IACE,6BAA6B;IAC7B,aAAa;IACb,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;;IAElB;MACE,aAAa;MACb,cAAc;MACd,uBAAuB;MACvB,QAAQ;MACR,kBAAkB;IACpB;;IAEA;MACE,2BAA2B;MAC3B,kBAAkB;MAClB,cAAc;MACd,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;IACnB;EACF;AACF;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;EACzC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;;EAEtB;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;;IAExB;MACE,aAAa;IACf;EACF;;EAEA;;IAEE,6BAA6B;IAC7B,gCAAgC;IAChC,eAAe;EACjB;;EAEA;IACE,6CAA6C;IAC7C,YAAY;EACd;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;AAC5C;;;AAGA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,WAAW;;EAEX;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;;IAER;MACE,WAAW;MACX,YAAY;IACd;EACF;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,SAAS;EACT,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;;EAEX;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;;IAElB;MACE,YAAY;MACZ,WAAW;IACb;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,0BAA0B;IAC5B;;;;;EAKF;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,gDAAgD;EAChD,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;;;;AAKA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,mCAAmC;;EAEnC;IACE,oBAAoB;IACpB,mBAAmB;IACnB,8BAA8B;;IAE9B;MACE,SAAS;MACT,eAAe;MACf,gBAAgB;MAChB,yBAAyB;MACzB,iBAAiB;MACjB,sBAAsB;IACxB;;IAEA;MACE,eAAe;MACf,uBAAuB;MACvB,YAAY;MACZ,aAAa;IACf;EACF;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;;EAEZ;IACE,qCAAqC;IACrC,wBAAwB;IACxB,4BAA4B;IAC5B,sCAAsC;IACtC,qBAAqB;IACrB,wBAAwB;;;;IAIxB;MACE,aAAa;IACf;;EAEF;;;EAGA;IACE,aAAa;EACf;;EAEA;IACE;MACE,aAAa;IACf;EACF;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;EACjB;AACF","sourcesContent":[".container {\n  width: 100%;\n  margin: 0 auto;\n  box-sizing: border-box;\n  max-height: 97vh;\n  height: 100%;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--f5-background);\n \n}\n\n.container::-webkit-scrollbar {\n  display: none;\n}\n\n@media (width <=768px) {\n  .container {\n    position: absolute;\n    width: 100vw;\n    max-width: 100vw;\n    z-index: 2;\n  }\n}\n\n\n\n\n\n\n\n.menuIcon {\n  width: 20px;\n  height: 20px;\n  color: var(--6b7280-color);\n}\n\n\n\n\n\n.labelsContainer {\n  display: flex;\n  gap: 8px;\n  padding-bottom: 8px;\n}\n\n\n\n\n\n.buttonActionsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n\n  .linkDisabled {\n    opacity: .2;\n    cursor: not-allowed;\n  }\n\n  button,\n  a {\n    font-size: 12px;\n    padding: 10px;\n    border: 1px solid var(--d9-background);\n    background-color: var(--fa-background);\n    outline: none;\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n    cursor: pointer;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    font-weight: bold;\n    color: black;\n    display: flex;\n    justify-content: start;\n    align-items: center;\n\n    img {\n      height: 22px;\n      width: 22px;\n    }\n  }\n\n  .btnWithText {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    justify-content: start !important;\n    font-weight: bold;\n  }\n\n  .btnAutomation {\n    justify-content: center;\n    height: 42px;\n\n    &:disabled {\n      opacity: .2;\n      cursor: not-allowed;\n    }\n\n    img {\n      height: 20px;\n      width: 20px;\n    }\n  }\n\n}\n\n.dragOver {\n  border: 2px dashed var(--3b82f6-background);\n  background-color: var(--e0f2fe-background);\n}\n\n\n\n.detailsContainer {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.btnTemplateContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.detailsContent {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.containerEditableInput {\n  padding: 0px 10px 10px;\n  border: 1px solid var(--ececf1-border);\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  background-color: var(--white-background);\n\n  .state {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .stateStripeContainer {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n}\n\n.searchContainerIcon {\n  background-color: var(--ececf1-background);\n  padding: 4px;\n  border-radius: 4px;\n  height: 10px;\n  width: 10px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  -ms-border-radius: 4px;\n  -o-border-radius: 4px;\n  cursor: pointer;\n}\n\n.searchIconsWrappers {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  background: var(--ececf1-background);\n  cursor: pointer;\n  user-select: none;\n  border-radius: 3px;\n}\n\n.headerBillMobile {\n  display: flex;\n  justify-content: space-between;\n\n  button {\n    background-color: transparent;\n    outline: none;\n    border: none;\n    color: var(--_292d32-color);\n    font-family: Inter;\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    cursor: pointer;\n  }\n\n  .notesHeaderBillMobile {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    position: relative;\n\n    .note {\n      display: flex;\n      padding: 0 5px;\n      align-items: flex-start;\n      gap: 3px;\n      border-radius: 5px;\n    }\n\n    button {\n      color: var(--_929598-color);\n      font-family: Inter;\n      font-size: 8px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 18px;\n    }\n  }\n}\n\n.verticalOptionDots {\n  transform: rotate(90deg);\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n}\n\n.button {\n  text-decoration: underline;\n  font-weight: 500;\n  cursor: pointer;\n  width: fit-content;\n}\n\n.note {\n  background-color: var(--_c2f2d3-background);\n  border: 1px solid var(--_0000001d-border);\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n\n  .text {\n    min-height: 40px;\n    height: fit-content;\n    max-height: 100px;\n    display: flex;\n    align-items: center;\n    overflow-y: scroll;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n  span,\n  input {\n    background-color: transparent;\n    font-family: \"Inter\", sans-serif;\n    font-size: 13px;\n  }\n\n  input {\n    background-color: var(--_9bd8b1fd-background);\n    border: none;\n  }\n}\n\n.tagWhite {\n  background-color: var(--white-background);\n}\n\n.tagRed {\n  background-color: var(--f2c6c2-background);\n}\n\n.tagOrange {\n  background-color: var(--f2cfc2-background);\n}\n\n.tagYellow {\n  background-color: var(--f2e3c2-background);\n}\n\n.tagGreen {\n  background-color: var(--_c2f2d3-background);\n}\n\n.tagBlue {\n  background-color: var(--c2d8f2-background);\n}\n\n\n.tagPink {\n  background-color: var(--f0c2f2-background);\n}\n\n.titleWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  width: 100%;\n\n  div {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    img {\n      width: 16px;\n      height: 22px;\n    }\n  }\n\n  button {\n    border: none;\n    outline: none;\n    background-color: transparent;\n    text-decoration: underline;\n    color: var(--_2-color);\n    font-weight: bold;\n  }\n\n  button:disabled {\n    color: var(--_b4-color);\n  }\n}\n\n.dropdown {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.dropdownContainer {\n  display: flex;\n  gap: 20px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  padding-bottom: 10px;\n  flex-wrap: wrap;\n  gap: 10px;\n  border-bottom: 1px solid var(--_11a3813c-border);\n}\n\n.dropdownCurrencyContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.titleContent {\n  width: 100%;\n}\n\n.title {\n  font-size: 18px;\n  font-weight: 500;\n  margin: 0;\n  color: var(--_084437-color);\n  width: 100%;\n  border-radius: 8px;\n  padding: 6px;\n  border: none;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  background-color: var(--f4-background);\n  outline: none;\n}\n\n.title::placeholder {\n  color: var(--_71717a-color);\n}\n\n.optionsPopupContainer {\n  position: absolute;\n  z-index: 9999;\n  bottom: -140px;\n  right: 2px;\n}\n\n.documentsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n\n  .document {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    position: relative;\n\n    img {\n      height: 30px;\n      width: 30px;\n    }\n\n    .acceptedDoc {\n      color: var(--009f7a-color);\n    }\n\n    .canceledDoc {\n      color: var(--c5221f-color);\n    }\n\n\n\n \n  }\n\n  .optionsPopupContainer {\n    position: absolute;\n    z-index: 9999;\n    bottom: -50px;\n    right: 2px;\n  }\n}\n\n.documentCanceledTag {\n  display: flex;\n  height: 31px;\n  padding: 5px 22px;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  gap: 10px;\n  align-self: stretch;\n  border-radius: 12px;\n  border: 1px solid var(--f4-chatAdmin-background);\n  background: var(--fff6d4-background);\n  color: var(--c5221f-color);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n}\n\n\n\n\n.logoSelectorContainer {\n  display: flex;\n  padding: 20px;\n  flex-direction: column;\n  gap: 15px;\n  flex: 1 0 0;\n  border-radius: 8px;\n  border: 1px solid var(--ececf1-border);\n  background: var(--white-background);\n}\n\n.qrContainer {\n  display: flex;\n  padding: 20px;\n  flex-direction: column;\n  gap: 15px;\n  flex: 1 0 0;\n  border-radius: 8px;\n  border: 1px solid var(--ececf1-border);\n  background: var(--white-background);\n\n  .qrHeader {\n    display: inline-flex;\n    align-items: center;\n    justify-content: space-between;\n\n    p {\n      margin: 0;\n      font-size: 14px;\n      font-weight: 500;\n      -webkit-user-select: none;\n      user-select: none;\n      color: var(--_2-color);\n    }\n\n    button {\n      cursor: pointer;\n      background: transparent;\n      border: none;\n      outline: none;\n    }\n  }\n\n  img {\n    width: 255px;\n    height: 250px;\n  }\n}\n\n.centedText {\n  margin: 0px auto 10px;\n  width: fit-content;\n  height: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  border-radius: 20px;\n  width: 90%;\n}\n\n.seeBillContainer {\n  position: relative;\n  /* border-radius: 8px; */\n  /* overflow: hidden; */\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  scroll-behavior: smooth;\n  height: 100%;\n\n  embed {\n    height: calc(100vh - 50px) !important;\n    /* border-radius: 8px; */\n    overflow: visible !important;\n    overflow-clip-margin: unset !important;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n\n    \n\n    &::-webkit-scrollbar {\n      display: none;\n    }\n\n  }\n\n\n  .seeBillContainer::-webkit-scrollbar {\n    display: none;\n  }\n\n  &:hover {\n    .seeBillContent {\n      display: flex;\n    }\n  }\n\n  .seeBillContent {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    padding: 10px 0;\n    display: none;\n    background-color: gray;\n    color: var(--white-color);\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_AVr7O`,
	"menuIcon": `menuIcon_e9a25`,
	"labelsContainer": `labelsContainer_gahu5`,
	"buttonActionsContainer": `buttonActionsContainer_l9gIC`,
	"linkDisabled": `linkDisabled_HQdoP`,
	"btnWithText": `btnWithText_fH1_H`,
	"btnAutomation": `btnAutomation_HRUlf`,
	"dragOver": `dragOver_QUp6Y`,
	"detailsContainer": `detailsContainer_xLRpm`,
	"btnTemplateContainer": `btnTemplateContainer_FNFJS`,
	"detailsContent": `detailsContent_LeQKe`,
	"containerEditableInput": `containerEditableInput_RRmrV`,
	"state": `state_UW3rZ`,
	"stateStripeContainer": `stateStripeContainer_F4Xu9`,
	"searchContainerIcon": `searchContainerIcon_h9vWg`,
	"searchIconsWrappers": `searchIconsWrappers_J36b6`,
	"headerBillMobile": `headerBillMobile_cMqTJ`,
	"notesHeaderBillMobile": `notesHeaderBillMobile_cP6CJ`,
	"note": `note_ffUiM`,
	"verticalOptionDots": `verticalOptionDots_nGSwK`,
	"button": `button_BOx4r`,
	"text": `text_asGg1`,
	"tagWhite": `tagWhite_Shkb5`,
	"tagRed": `tagRed_nVOXP`,
	"tagOrange": `tagOrange_ftvl9`,
	"tagYellow": `tagYellow_UQu9r`,
	"tagGreen": `tagGreen_PbDrp`,
	"tagBlue": `tagBlue_h5m1q`,
	"tagPink": `tagPink_LaP10`,
	"titleWrapper": `titleWrapper_Hetit`,
	"dropdown": `dropdown_eLjFE`,
	"dropdownContainer": `dropdownContainer_auOu3`,
	"header": `header_zbNfG`,
	"dropdownCurrencyContainer": `dropdownCurrencyContainer_qOQlk`,
	"titleContent": `titleContent_uTIEm`,
	"title": `title_BYlhs`,
	"optionsPopupContainer": `optionsPopupContainer_OybaP`,
	"documentsContainer": `documentsContainer_E82Cu`,
	"document": `document_qek7C`,
	"acceptedDoc": `acceptedDoc_h3s8p`,
	"canceledDoc": `canceledDoc_je_49`,
	"documentCanceledTag": `documentCanceledTag_MC_0W`,
	"logoSelectorContainer": `logoSelectorContainer_ugSmL`,
	"qrContainer": `qrContainer_VFzpL`,
	"qrHeader": `qrHeader_F3Vsu`,
	"centedText": `centedText_tsZzv`,
	"seeBillContainer": `seeBillContainer_WemQi`,
	"seeBillContent": `seeBillContent_rgwZc`
};
export default ___CSS_LOADER_EXPORT___;
